export default __webpack_public_path__ + "navigation-examples-offline-regions-1200-1d0951b2806c25333dc6a0b41fefeeb5.png";